interface TimestampMeta {
  receivedAt?: number
  [key: string]: unknown
}

interface TimestampAction {
  meta?: TimestampMeta
  [key: string]: unknown
}

type Next = (action: TimestampAction) => unknown

export default () => (next: Next) => (action: TimestampAction) => {
  action.meta ??= {}
  action.meta.receivedAt ??= Date.now()
  return next(action)
}
